import { WallpaperImageRes } from "@/api/model"
import { BizError, BizResult, Ok } from "@/models/biz_model"
import { ERR_APPLY_DESKTOP_WALLPAPER } from "@/models/constants"
import { KCSDK } from "@/sdk"
import { DesktopIdWallpaperCache } from "@/utils/storage"
import { UserUsecase } from "./user"

export interface NetworkWallpaperItem extends WallpaperImageRes {}

async function setDesktopWallpaper(
  wallpaper: NetworkWallpaperItem
): Promise<BizResult<number>> {
  if (wallpaper.img.trim() === "" || wallpaper.resource_id.trim() === "") {
    return new BizError(ERR_APPLY_DESKTOP_WALLPAPER)
  }

  const desktopId = UserUsecase.getCurrentUser()?.desktopId
  if (!desktopId) {
    return new BizError(ERR_APPLY_DESKTOP_WALLPAPER)
  }

  const result = await KCSDK.setWallpaper(wallpaper.img)
  if (result !== 0) {
    return new BizError(result || ERR_APPLY_DESKTOP_WALLPAPER)
  }

  DesktopIdWallpaperCache.setDesktopIdWallpaper(desktopId, wallpaper.img)
  return new Ok(0)
}

function getCurrentDesktopWallpaper(): string | null {
  const desktopId = UserUsecase.getCurrentUser()?.desktopId
  if (!desktopId) {
    return null
  }
  return DesktopIdWallpaperCache.getDesktopIdWallpaper(desktopId)
}

export const WallpaperUseCase = {
  setDesktopWallpaper,
  getCurrentDesktopWallpaper,
}
